<script setup>
import { defineProps, defineEmits } from "vue";

const props = defineProps({
    isOpen: Boolean,
});

const emit = defineEmits(["close"]);

function close() {
    emit("close");
}
</script>

<template>
    <teleport to="body">
        <div v-if="isOpen" class="c-modal">
            <button class="c-modal__close" @click="close">×</button>
            <div class="c-modal__wrapper">
                <div class="c-modal__inner">
                    <slot></slot>
                </div>
            </div>
        </div>
    </teleport>
</template>
